<template>
  <el-dialog
    title="Tracking Subscriptions"
    :visible.sync="isVisible"
    :close-on-click-modal="false"
  >
    <el-row>
      <el-table
        v-loading="isLoading"
        :data="consignment.tracking_subscriptions"
        style="width: 100%"
      >
        <el-table-column
          prop="type.name"
          label="Type"
        />
        <el-table-column
          prop="email"
          label="Email"
        />
        <el-table-column
          label="Created At"
          prop="created_at"
          :formatter="(row, col, cellValue) => cellValue ? $moment(cellValue).format('DD/MM/YYYY hh:mm a') : '-'"
        />
        <el-table-column
          label="Deleted At"
          prop="deleted_at"
          :formatter="(row, col, cellValue) => cellValue ? $moment(cellValue).format('DD/MM/YYYY hh:mm a') : '-'"
        />
        <el-table-column label="Actions">
          <template slot-scope="scope">
            <el-button
              type="danger"
              plain
              size="small"
              @click="scope.row.delete()"
            >
              Delete
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-divider />
    <el-row>
      <el-form label-width="120px">
        <el-row>
          <el-col :md="8">
            <el-form-item
              v-loading="isLoadingTypes"
              label="Type"
            >
              <el-select
                v-model="subscription.type"
                placeholder="Select A Type"
                value-key="id"
              >
                <el-option
                  v-for="(type) in types"
                  :key="type.id"
                  :label="type.name"
                  :value="type"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md="8">
            <el-form-item
              label="Email"
            >
              <el-input
                v-model="subscription.email"
                type="text"
              />
            </el-form-item>
          </el-col>
          <el-col :md="8">
            <el-form-item>
              <el-button
                type="primary"
                @click.native="subscribe"
              >
                Subscribe
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-row>
  </el-dialog>
</template>
<script>
export default {
  props: {
    consignment: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isLoading: false,
      isLoadingTypes: true,
      isVisible: true,
      subscription: {},
      types: []
    }
  },
  created () {
    this.loadTypes()
    this.subscription.email = this.$user.instance.email
  },
  methods: {
    promptDeletionConfirmation (subscription) {
      this
        .$prompt(
          'Are you sure you wish to remove this subscription',
          `Remove Subscription`,
          {
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Cancel',
            callback: async (action, instance) => {
              if (action === 'confirm') {
                await subscription.delete()
                await this.consignment.tracking_subscriptions.refresh()
                this.isVisible = false
                this.$message({ message: 'Subscription Removed', type: 'success' })
              }
            }
          }
        )
    },
    loadTypes () {
      this.$sdk.type.list(builder => {
        builder.page = 1
        builder.limit = 1000
        builder.order = 'name:asc'
      }).then(res => {
        this.types = res
        this.isLoadingTypes = false
      })
    },
    subscribe () {
      this.isLoading = true
      this.$sdk.tracking_subscription.create({
        type: this.subscription.type,
        email: this.subscription.email,
        consignment: this.consignment
      }).then(async res => {
        this.$message({ message: 'Subscription Added', type: 'success' })
        this.isLoading = false
        this.isVisible = false
      })
    }
  }
}
</script>
